export default __webpack_public_path__ + "static/media/ModeleAddPdvs.213d191a.xlsx";